module.exports = "https://static.wanderu.com/static/media/hero-header.54ff18d4.svg";